/**
 * Skeleton coerente col `BillTrendChart` reale (AreaChart cyan, line + dots).
 *
 * Disegna una polilinea SVG di placeholder sopra una griglia tratteggiata
 * e ne fa pulsare l'area sotto. Niente barre verticali: l'attesa visiva
 * deve combaciare col grafico finale.
 */

import { cn } from '@/lib/utils'

const POINTS = [
  [0, 70],
  [10, 55],
  [20, 60],
  [30, 45],
  [40, 50],
  [50, 35],
  [60, 40],
  [70, 30],
  [80, 38],
  [90, 25],
  [100, 30],
] as const

export function BillTrendChartSkeleton() {
  const linePath = POINTS.map(([x, y], i) => `${i === 0 ? 'M' : 'L'} ${x} ${y}`).join(' ')
  const areaPath = `${linePath} L 100 100 L 0 100 Z`

  return (
    <div className={cn('relative h-[220px] w-full animate-pulse')}>
      <svg
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
        className="h-full w-full"
        aria-hidden
      >
        {/* griglia orizzontale tratteggiata */}
        {[20, 40, 60, 80].map((y) => (
          <line
            key={y}
            x1="0"
            x2="100"
            y1={y}
            y2={y}
            stroke="hsl(var(--border))"
            strokeWidth="0.3"
            strokeDasharray="1 1.5"
          />
        ))}

        <defs>
          <linearGradient id="bill-trend-skeleton-fill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="hsl(var(--muted-foreground))" stopOpacity={0.35} />
            <stop offset="100%" stopColor="hsl(var(--muted-foreground))" stopOpacity={0} />
          </linearGradient>
        </defs>

        <path d={areaPath} fill="url(#bill-trend-skeleton-fill)" />
        <path
          d={linePath}
          fill="none"
          stroke="hsl(var(--muted-foreground))"
          strokeWidth="1"
          strokeLinejoin="round"
          strokeLinecap="round"
          opacity="0.6"
        />

        {/* dot placeholder */}
        {POINTS.map(([x, y]) => (
          <circle
            key={`${x}-${y}`}
            cx={x}
            cy={y}
            r="0.9"
            fill="hsl(var(--muted-foreground))"
            opacity="0.6"
          />
        ))}
      </svg>
    </div>
  )
}
